import React, {
    useState,
    useRef,
    useEffect,
    useCallback,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import { ErrorBar } from "../../Components/ErrorBar";
import { FtchPlusError, ScenarioUrl_spec, empty_uuid, ftchPlus, getOptions } from "../../App/Account_urls";
import { Box, Paper, Stack } from "@mui/material";
import { Help_IncomeGrid } from "../Help/Help_Grids";
import { GoogleAnalyticsEvent } from "../../Components/ga4";
import { autoSizeStrategy, columnTypes, defaultColDef, onHeaderClicked, UpdateColumnGroupIds, UpdateTooltips } from "../../Pages/GridScenario";
import { GridHeader } from "../../Components/GridHeader";
import { Arrayify } from "../../Functions/utils";


const IncomeGrid = ({
    clientJson,
    scen_uuid,
    scen_name,
    width,
    height,
    onClose,
    onExpand,
    name = "Income"
}) => {
    const gridRef = useRef(null);
    const clientData = useRef(null);
    const [client, setClient] = useState("");
    const [clients, setClients] = useState([]);
    const [dataSets, setDataSets] = useState([]);
    const [dataSet, setDataSet] = useState("");
    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [topRowData, setTopRowData] = useState([]);
    const [bottomRowData, setBottomRowData] = useState([]);
    const [showSums, setShowSums] = useState(false);
    const [loading, setLoading] = useState(true)

    const [errmsg, setErrmsg] = useState("")

    const onRowDataUpdated = useCallback((event) => {
        event.api.autoSizeAllColumns();
    }, []);



    const getData = async () => {
        setLoading(true)
        console.log(clientJson);
        if (scen_uuid && scen_uuid !== empty_uuid) {
            console.log(clientJson.Scenario);
            GoogleAnalyticsEvent("grid", "view", "income", { action: "view", type: "income" })
            var url = ScenarioUrl_spec(clientJson, scen_uuid, "income", "");

            ftchPlus(url, getOptions)
                .then((json) => {
                    console.log(json);
                    clientData.current = json.ClientData;
                    setClients(json.Clients);
                    setDataSets(json.DataSets);
                    const cl = json.Clients[0];
                    setClient(cl);
                    const ds = json.DataSets[0];
                    setDataSet(ds);
                    Update(cl, ds);
                    setLoading(false)

                })
                .catch((error) => {
                    console.log(error.message);
                    setErrmsg(error.message)
                    FtchPlusError(error)
                    setLoading(false)

                });
        }
    };

    const btnClientChanged = (value) => {
        setClient(value);
        Update(value, dataSet);
    };

    const btnDataSetChanged = (value) => {
        setDataSet(value);
        Update(client, value);
    };

    // load data from sever
    useEffect(() => {
        setErrmsg("")
        getData();
        setLoading(true)

    }, [clientJson]);


    const onShowSums = (n, v) => {
        setShowSums(v)
        setTopRowData([])
        setBottomRowData([])

        updateSums(v, client, dataSet)
    }


    const updateSums = (show, cl, ds) => {
        if (show) {
            if (clientData.current[cl][ds].TopRow) {
                clientData.current[cl][ds].TopRow[0].year = "Aggregate"
                for (let i = 0; i < clients.length; i++) {
                    clientData.current[cl][ds].TopRow[0][clients[i] + ":age"] = ""
                }

                setTopRowData(Arrayify(clientData.current[cl][ds].TopRow))
            }
        }
    }
    const displayShowSums = () => {
        if (clientData.current && clientData.current[client][dataSet].TopRow) {
            return onShowSums
        }
        return null
    }


    const Update = (cl, ds) => {
        let headers = UpdateColumnGroupIds(clientData.current[cl][ds].Headers, "")
        headers = UpdateTooltips(headers)
        setColumnDefs(headers);

        setRowData(clientData.current[cl][ds].Data);
        updateSums(showSums, cl, ds)
    };

    const gridRefFn = () => {
        return gridRef
    }


    return (
        <Paper>
            <Box sx={{ p: 4 }}>
                <Stack spacing={4}>
                    <GridHeader
                        name={name}
                        clientJson={clientJson}
                        scenName={scen_name}
                        clients={clients}
                        client={client}
                        onClientChange={btnClientChanged}
                        dataSets={dataSets}
                        dataSet={dataSet}
                        onDataSetChange={btnDataSetChanged}
                        onExpand={onExpand}
                        onClose={onClose}
                        gridRefFn={gridRefFn}
                        showSums={showSums}
                        onShowSums={displayShowSums()}
                    />
                    <div
                        className="ag-theme-alpine"
                        style={{
                            width: "100%", height: height
                        }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData} // Row Data for Rows
                            pinnedTopRowData={topRowData}
                            pinnedBottomRowData={bottomRowData}
                            rowHeight={32}
                            columnDefs={columnDefs} // Column Defs for Columns
                            defaultColDef={defaultColDef} // Default Column Properties
                            columnTypes={columnTypes}
                            tooltipShowDelay={1200}
                            //rowSelection= {mode="singleRow"}
                            onRowDataUpdated={onRowDataUpdated}
                            autoSizeStrategy={autoSizeStrategy}
                            autoSizePadding={8}
                            animateRows={false} // Optional - set to 'true' to have rows animate when sorted
                            onColumnHeaderClicked={onHeaderClicked}
                            loading={loading}

                        />
                    </div>
                    <Help_IncomeGrid />
                    <ErrorBar error={errmsg} />
                </Stack>
            </Box>
        </Paper >
    );
};



export default IncomeGrid;
